import Vue from "vue";

export default {
  name: "App",
  components: {},
  data: function() {
    return {
      percentMin: 19,
      percentMax: 80,
      serviceGoal: 5000,
      serviceCount: 0,
      easterEggRevealIncrement: 0
    };
  },
  mounted: function() {
    var vm = this;

    return Vue.appApi()
      .guest()
      .getServiceCount()
      .then(setCount);

    function setCount(response) {
      vm.serviceCount = response.data.values[0][0];
    }
  },
  computed: {
    maskString: function() {
      return `-webkit-linear-gradient(black ${
        this.blackPercentComputed
      }%, transparent ${this.transparentPercentComputed}%)`;
    },
    percentOfGoal: function() {
      return ((this.serviceCount / this.serviceGoal) * 100).toFixed(2);
    },
    blackPercentComputed: function() {
      return (
        this.percentMax -
        (this.percentOfGoal / 100) * (this.percentMax - this.percentMin) -
        this.easterEggRevealIncrement
      );
    },
    transparentPercentComputed: function() {
      return this.blackPercentComputed + 5;
    }
  },
  methods: {
    incrementGradient: function() {
      this.easterEggRevealIncrement = this.easterEggRevealIncrement + 1;
    }
    // getServiceCount: function() {
    //   return Vue.appApi()
    //     .guest()
    //     .getServiceCount()
    //     .then(setCount);

    //   function setCount(response) {
    //     var dbugThis = true;
    //     if (dbugThis) {
    //       console.log("%c  ", "color:grey");
    //     }
    //   }
    // },
    // recordService: function() {
    //   var payload = { values: ["here is my message"] };

    //   Vue.appApi()
    //     .guest()
    //     .recordService()
    //     .then(showSuccess);

    //   function showSuccess(response) {
    //   }
    // }
  }
};
